export default __webpack_public_path__ + "static/media/codecrush1.b9c135cb.jpg";